import { Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
  })

export class ScriptService {
 
  constructor(
    @Inject(DOCUMENT) private document: Document
  ) { }
 
  /**
  * Append the JS tag to the Document Head.
  * @param renderer The Angular Renderer
  * @param UrlSrc The path to the script
  * @returns the script element
  */
  public loadJsScriptURL(renderer: Renderer2, UrlSrc: string): HTMLScriptElement {
    const script = renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = UrlSrc;
    renderer.appendChild(this.document.head, script); 
    return script;
  }

  public loadJsScript(renderer: Renderer2, srcText: string): HTMLScriptElement {
    const script = renderer.createElement('script');
    script.type = 'text/javascript';
    script.text = srcText;
    renderer.appendChild(this.document.head, script); 
    return script;
  }

}